import gql from 'graphql-tag';

export default gql`
  query itemFullHistoryContent(
    $moduleName: String
    $selectedRow: ItemHistoryRowInput
  ) {
    itemFullHistoryContent(moduleName: $moduleName, selectedRow: $selectedRow) {
      InvoiceDate
      Quantity
      Price
    }
  }
`;
